import { useAtom, atom } from 'jotai'
import { useLocation, useNavigate } from 'react-router-dom';
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';
import { getInquiryList } from "../../api/api";
import { isoDateToStr } from "../../api/api_util";
import { INQUIRY_LIST_MAX_COUNT, DATA_PAR_PAGE } from "../../config";
import ReactPaginate from "react-paginate";
import React from 'react';
import { useEffect } from 'react';
import Maintenance from "../inquiry_create/maintenance";

const buttonStyle = {
    border: "none",
    textAlign: "left",
    color: "#069",
    textDecoration: "underline",
    cursor: "pointer"
};

const customerStatusName = {
    0: "全て",
    1: "クローズ以外",
    2: "NEC調査中",
    3: "お客様連絡待ち",
    4: "クローズ",
}

const pageNumberAtom = atom(0);
const dataLengthAtom = atom();
const pageCountAtom = atom();
const isSubmitAtom = atom(false);
const dataAtom = atom();
const searchEndUserAtom = atom();
const searchAccNumAtom = atom("");
const searchDateFromAtom = atom();
const searchDateToAtom = atom();
const searchCustomerStatusAtom = atom("全て");
const searchCustomerStatusNumAtom = atom();
const sortNumberAtom = atom(3);
const sortOrderAtom = atom(1);

function MainComponent({ handleLoading }) {

    document.title = "お問い合わせ(継続／状況確認)| ファーストコンタクトセンター";
    const navigate = useNavigate();
    const location = useLocation()
    const [isSubmit, setIsSubmit] = useAtom(isSubmitAtom);
    const [data, setData] = useAtom(dataAtom);
    const [pageNumber, setPageNumber] = useAtom(pageNumberAtom)
    const [cnt, setCnt] = useAtom(dataLengthAtom);
    const [pageCount, setPageCount] = useAtom(pageCountAtom);
    const [searchEndUser, setEndUser] = useAtom(searchEndUserAtom);
    const [searchAccNum, setAccNum] = useAtom(searchAccNumAtom);
    const [searchDateFrom, setDateFrom] = useAtom(searchDateFromAtom);
    const [searchDateTo, setDateTo] = useAtom(searchDateToAtom);
    const [searchCustomerStatus, setCustomerStatus] = useAtom(searchCustomerStatusAtom);
    const [searchCustomerStatusNum, setSearchCustomerStatusNum] = useAtom(searchCustomerStatusNumAtom);
    const [sortNumber, setSortNumber] = useAtom(sortNumberAtom);
    const [sortOrder, setSortOrder] = useAtom(sortOrderAtom);

    useEffect(() => {

        if (!searchAccNum) {
            document.getElementById("receipt_num").value = "";
        } else {
            document.getElementById("receipt_num").value = searchAccNum;

        }

        if (!searchCustomerStatusNum) {
            document.getElementById("status").value = "0";
        }
        else {
            document.getElementById("status").value = searchCustomerStatusNum;
        }

        if (!searchEndUser) {
            document.getElementById("end_user").value = "";
        } else {
            document.getElementById("end_user").value = searchEndUser;

        }

        if (searchDateFrom === undefined) {
            document.getElementById("inquiry_start").value = "";
        } else {
            document.getElementById("inquiry_start").value = searchDateFrom;

        }

        if (searchDateTo === undefined) {
            document.getElementById("inquiry_end").value = "";
        } else {
            document.getElementById("inquiry_end").value = searchDateTo;

        }
    }
    )

    const handleMouseEnter = (event) => {
        event.target.style.textDecoration = 'none';
    };

    const handleMouseLeave = (event) => {
        event.target.style.textDecoration = 'underline';
    };

    const changePage = (data => {
        let selectedPageNumber = data['selected'];
        setPageNumber(selectedPageNumber);
    });

    if (!location.state) {
        location.state = {
            page: false,
            pageSubmit: false,
        };
    }
    try {
        if (location.state.pageSubmit === false) {
            setIsSubmit(location.state.pageSubmit)
            location.state.pageSubmit = true
        }
    } catch (e) {
        ; // TODO エラー表示
    }
    function initInput() {
        setIsSubmit(false);
        setData(null);
        setPageNumber(0);
        setCnt(null);
        setPageCount(null);
        setEndUser(null);
        setAccNum("");
        setDateFrom(undefined);
        setDateTo(undefined);
        setCustomerStatus(customerStatusName[0]);
        setSearchCustomerStatusNum(null);
        setSortNumber(3);
        setSortOrder(1);
    }

    if (location.state.page === true) {
        initInput();
        location.state.page = false;
    }

    if (location.state.page === "return") {
        setEndUser(location.state.searchEndUser);
        setAccNum(location.state.searchAccNum);
        setDateFrom(location.state.searchDateFrom);
        setDateTo(location.state.searchDateTo);
        setSearchCustomerStatusNum(location.state.searchCustomerStatusNum);
        location.state.page = false;
    }

    const handleEndUser = (event) => {
        setEndUser(event.target.value)
    }

    const handleAccNum = (event) => {
        setAccNum(event.target.value)
    }

    const handleDateFrom = (event) => {

        setDateFrom(event.target.value)

    }

    const handleDateTo = (event) => {
        setDateTo(event.target.value)
    }

    const handleCustomerStatus = (event) => {
        setCustomerStatus(customerStatusName[event.target.value]);
        setSearchCustomerStatusNum(event.target.value);
    }

    const checkValue = (obj) => {
        let emptyValues = ["", undefined, null, false];
        if (emptyValues.includes(obj)) {
            return ""
        } else {
            return obj
        }
    }

    const compareDates = () => {
        let dateFrom = new Date(searchDateFrom).getTime();
        let dateTo = new Date(searchDateTo).getTime();
        let today = new Date().toISOString().slice(0, 10);
        let dateToday = new Date(today).getTime();
        let date_value_start = document.getElementById("inquiry_start").validity.valid
        let date_value_end = document.getElementById("inquiry_end").validity.valid

        if (date_value_start === false) {
            alert("不正な日付が入力されています。日付の入力を見直してください。");
            return false;
        }
        if (date_value_end === false) {
            alert("不正な日付が入力されています。日付の入力を見直してください。");
            return false;
        }
        if (dateFrom > dateToday || dateTo > dateToday) {
            alert("お問い合わせ日の範囲指定が間違っています。お問い合わせ日の範囲の指定は今日以前の日付にしてください。");
            return false;
        }
        if (dateFrom > dateTo) {
            alert("お問い合わせ日の範囲指定が間違っています。お問い合わせ日の範囲の指定は開始日を終了日以前の日付にしてください。");
            return false;
        }
        return true;
    }

    const searchInq = async (event, sort_number, sort_order) => {

        var ret;
        let allCount;
        const re = /^[0-9\b]+$/;
        if (!re.test(searchAccNum) && searchAccNum !== "") {
            alert("数値以外入力できません。");
            return;
        }
        if (compareDates() === false) {
            return;
        }
        setIsSubmit(false);
        handleLoading(true);
        if (searchEndUser ? searchEndUser.trim() : searchEndUser || searchAccNum || searchDateFrom || searchDateTo || searchCustomerStatus) {
            ret = await getInquiryList(
                sort_number,
                sort_order,
                checkValue(searchEndUser ? searchEndUser.trim() : searchEndUser),
                checkValue(searchAccNum),
                checkValue(searchDateFrom),
                checkValue(searchDateTo),
                checkValue(searchCustomerStatus),
            );

        } else {
            ret = await getInquiryList(
                sort_number,
                sort_order
            );
        }
        setSortNumber(sort_number);
        setSortOrder(sort_order);
        if (ret === false) {
            setData(null);
            setCnt(null);
            allCount = null;
            setPageNumber(0);
            setPageCount(null)
            setIsSubmit(false);
            alert("現在サーバーが込み合っているか、または、システムメンテナンス中です。時間を置いて再試行してください。")
        } else {
            if (ret.records) {
                setData(ret.records);
                setCnt(ret.records.length);
                allCount = ret.allCount;
                setPageNumber(0);
                setPageCount(Math.ceil(ret.records.length / DATA_PAR_PAGE));
                setIsSubmit(true);
            } else {
                setData([]);
                setCnt(0);
                allCount = 0;
                setPageNumber(0);
                setPageCount(0);
                setIsSubmit(true);
            }
        }
        handleLoading(false);

        if (allCount > INQUIRY_LIST_MAX_COUNT) {
            setCnt(INQUIRY_LIST_MAX_COUNT);
            setIsSubmit(true);
            alert(`検索結果が上限（${INQUIRY_LIST_MAX_COUNT}件）を超えたため、一部の検索結果を表示できません。検索条件を絞り込んで再度検索を実行してください。`);
            return;
        }

    }

    const changeSort = async (event, sort_number) => {
        var sort_order = 1;
        if (sortNumber === sort_number) {
            sort_order = sortOrder === 1 ? 2 : 1;
        }
        searchInq(event, sort_number, sort_order);
    }
    const SearchResult = () => {
        if (data) {
            if (data.length === 0) {
                return (
                    <>
                        <div>
                            <div id="inquiry_ranges" className="mod-txt">

                                <p>お問い合わせ件数 0件</p>
                            </div>
                        </div>
                    </>
                )
            }

            return (
                <>
                    <div>
                        <div id="inquiry_ranges" className="mod-txt">
                            <p>お問い合わせ件数 {cnt}件</p>
                        </div>
                        <div className="mod-txt">
                            ＊継続お問い合わせの履歴/状況を確認する場合、最初に問い合わせた際の受付番号をクリックして確認が可能です。
                        </div>
                        <div id="inquiry_list" className="mod-tbl">
                            <table>
                                <colgroup>
                                    <col className="w-20" />
                                    <col className="w-35" />
                                    <col className="w-20" />
                                    <col className="w-25" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th rowSpan="2">
                                            <span onClick={event => changeSort(event, 1)}> 受付番号 </span>
                                            <button style={{ borderStyle: "none" }} onClick={event => changeSort(event, 1)}>
                                                {sortNumber === 1 ? (sortOrder === 1 ? <FaSortUp /> : <FaSortDown />) : <FaSort />}
                                            </button>
                                        </th>
                                        <th>
                                            <span onClick={event => changeSort(event, 7)}> 件名 </span>
                                            <button style={{ borderStyle: "none" }} onClick={event => changeSort(event, 7)}>
                                                {sortNumber === 7 ? (sortOrder === 1 ? <FaSortUp /> : <FaSortDown />) : <FaSort />}
                                            </button>
                                        </th>
                                        <th>
                                            <span onClick={event => changeSort(event, 6)}> お客様名(エンドユーザ様名) </span>
                                            <button style={{ borderStyle: "none" }} onClick={event => changeSort(event, 6)}>
                                                {sortNumber === 6 ? (sortOrder === 1 ? <FaSortUp /> : <FaSortDown />) : <FaSort />}
                                            </button>
                                        </th>
                                        <th>
                                            <span onClick={event => changeSort(event, 4)}> 状況</span>
                                            <button style={{ borderStyle: "none" }} onClick={event => changeSort(event, 4)}>
                                                {sortNumber === 4 ? (sortOrder === 1 ? <FaSortUp /> : <FaSortDown />) : <FaSort />}
                                            </button>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span onClick={event => changeSort(event, 2)}> 製品名</span>
                                            <button style={{ borderStyle: "none" }} onClick={event => changeSort(event, 2)}>
                                                {sortNumber === 2 ? (sortOrder === 1 ? <FaSortUp /> : <FaSortDown />) : <FaSort />}
                                            </button>
                                        </th>
                                        <th>
                                            <span onClick={event => changeSort(event, 3)}> お問い合わせ日時</span>
                                            <button style={{ borderStyle: "none" }} onClick={event => changeSort(event, 3)}>
                                                {sortNumber === 3 ? (sortOrder === 1 ? <FaSortUp /> : <FaSortDown />) : <FaSort />}
                                            </button>
                                        </th>
                                        <th>
                                            <span onClick={event => changeSort(event, 5)}> 更新日時</span>
                                            <button style={{ borderStyle: "none" }} onClick={event => changeSort(event, 5)}>
                                                {sortNumber === 5 ? (sortOrder === 1 ? <FaSortUp /> : <FaSortDown />) : <FaSort />}
                                            </button>
                                        </th>
                                    </tr>
                                </thead>
                                {data
                                    .slice(pageNumber * DATA_PAR_PAGE, (pageNumber + 1) * DATA_PAR_PAGE)
                                    .map((val, index) =>
                                        <tbody key={index + " key"}>
                                            <tr key={index + "top"}>
                                                <td rowSpan="2" key={index + "QID"}>
                                                    <button
                                                        className="acceptanceNumber"
                                                        style={buttonStyle}
                                                        onMouseEnter={handleMouseEnter}
                                                        onMouseLeave={handleMouseLeave}
                                                        onClick={() => {
                                                            navigate("/relation_inquiry_create",
                                                                {
                                                                    state: {
                                                                        acceptanceNumber: val.acceptanceNumber,
                                                                        inquiryCategory: "",
                                                                        questionArea: "",
                                                                        attachedFile: "",
                                                                        searchAccNum,
                                                                        searchDateFrom,
                                                                        searchDateTo,
                                                                        searchCustomerStatusNum,
                                                                        searchEndUser,
                                                                        page: true
                                                                    }
                                                                }
                                                            );
                                                        }}
                                                        key={index + "acceptanceNumber.a"} >{val.acceptanceNumber}
                                                    </button>
                                                </td>
                                                <td key={index + "subject"}>
                                                    <button
                                                        style={buttonStyle}
                                                        onMouseEnter={handleMouseEnter}
                                                        onMouseLeave={handleMouseLeave}
                                                        onClick={() => {
                                                            navigate("/relation_inquiry_create",
                                                                {
                                                                    state: {
                                                                        acceptanceNumber: val.acceptanceNumber,
                                                                        inquiryCategory: "",
                                                                        questionArea: "",
                                                                        attachedFile: "",
                                                                        searchAccNum,
                                                                        searchDateFrom,
                                                                        searchDateTo,
                                                                        searchCustomerStatusNum,
                                                                        searchEndUser,
                                                                        page: true
                                                                    }
                                                                }
                                                            );
                                                        }}
                                                        key={index + "subject.a"}>{val.subject}
                                                    </button>
                                                </td>
                                                <td key={index + "customerName"}>{val.customerName}</td>
                                                <td key={index + "customerStatus"}>{val.customerStatus}</td>
                                            </tr>
                                            <tr key={index + "bottom"}>
                                                <td key={index + "productName"}> {val.productName} </td>
                                                <td key={index + "acceptanceDateTime"}> {isoDateToStr(val.acceptanceDateTime)} </td>
                                                <td key={index + "lastModifiedDate"}> {isoDateToStr(val.lastModifiedDate)} </td>
                                            </tr>
                                        </tbody>
                                    )}

                            </table>
                        </div>
                    </div >
                </>
            );
        }

    };

    return (
        <>
            < div className="ls-row str-column-main" id="ls-row-3-col-1-row-2-col-2-row-1" >
                <div className="str-outer">
                    <div className="str-inner">
                        <div className="mod-hdg-l1">
                            <div className="inner">
                                <h1 className="hdg">Web問い合わせシステム</h1>
                                <span className="sub of-top">NEC ファーストコンタクトセンター</span>
                            </div>
                        </div>
                        <h2 className="mod-hdg-l2-02">
                            <span>お問い合わせ(継続／状況確認)</span>
                        </h2>
                        <Maintenance />
                        {/* 表示位置の高さをそろえるため。CSSの関係で追加している要素で動作はしない */}
                        <form id="queryForm" name="queryForm">  </form>
                        <h4 className="mod-hdg-l4-02">
                            以下の条件で絞り込んで検索
                        </h4>
                        <div className="mod-tbl-form mb-30">
                            <table role="presentation">
                                <colgroup>
                                    <col className="w-25" />
                                    <col className="w-20" />
                                    <col className="w-5" />
                                    <col className="w-20" />
                                    <col />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b><span htmlFor="section">受付番号</span></b>
                                            </div>
                                        </td>
                                        <td colSpan="3">
                                            <div className="mod-input">
                                                <input type="text" id="receipt_num" name="receipt_num" maxLength="10" style={{ maxWidth: '70%', imeMode: "inactive" }}
                                                    placeholder="例：123456789" defaultValue={searchAccNum ? searchAccNum : null} onChange={handleAccNum} />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b><span htmlFor="section">お問い合わせ日</span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input">
                                                <input type="date" id="inquiry_start" name="inquiry_start" max="9999-12-31" maxLength="10" onChange={handleDateFrom} />
                                            </div>
                                        </td>
                                        <td>
                                            <p style={{ textAlign: "center" }}>
                                            </p>
                                        </td>
                                        <td>
                                            <div className="mod-input">
                                                <input type="date" id="inquiry_end" name="inquiry_end" max="9999-12-31" maxLength="10" onChange={handleDateTo} />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b><span htmlFor="section">お問い合わせ状況</span></b>
                                            </div>
                                        </td>
                                        <td colSpan="3">
                                            <div className="mod-input">
                                                <li>
                                                    <div className="mod-input-select">
                                                        <span className="wrap">
                                                            <select id="status" name="status" defaultValue={searchCustomerStatusNum ? searchCustomerStatusNum : "0"} onChange={handleCustomerStatus}>
                                                                <option value="0">全て</option>
                                                                <option value="1">クローズ以外</option>
                                                                <option value="2">NEC調査中</option>
                                                                <option value="3">お客様連絡待ち</option>
                                                                <option value="4">クローズ</option>
                                                            </select>
                                                        </span>
                                                    </div>
                                                </li>
                                                <input type="hidden" id="select_status" name="select_status" />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b><span htmlFor="section">お客様名(エンドユーザ様名)</span></b>
                                            </div>
                                        </td>
                                        <td colSpan="3">
                                            <div className="mod-input">
                                                <input type="text" id="end_user" name="end_user" maxLength="128" defaultValue={searchEndUser ? searchEndUser : null} style={{ maxWidth: '70%' }}
                                                    placeholder="例：○○株式会社" onChange={handleEndUser} />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="mod-btn of-no-arrow">
                            <div className="btn">
                                <button id="btn-search" onClick={event => searchInq(event, 3, 2)}>検索する</button>

                            </div>

                        </div>

                        {isSubmit === true && cnt <= INQUIRY_LIST_MAX_COUNT ? <SearchResult /> : null}
                        {isSubmit === true && data && data.length !== 0 && cnt <= INQUIRY_LIST_MAX_COUNT ? <ReactPaginate
                            pageCount={pageCount}
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={1}
                            onPageChange={changePage}
                            containerClassName={"paginationBttns"}
                            // pageClassName='page-item' //各子要素(li要素)のクラス名
                            // pageLinkClassName='page-link' //ページネーションのリンクのクラス名
                            activeClassName={"pagintaionActive"}
                            previousLabel={"Prev"}
                            nextLabel={"Next"}
                            // previousClassName='page-item' // '<'の親要素(li)のクラス名
                            // nextClassName='page-item' //'>'の親要素(li)のクラス名
                            previousLinkClassName={"previousBttn"}
                            nextLinkClassName={"nextBttn"}
                            disabledClassName={"paginationDisabled"}
                            breakLabel='...'
                        // breakClassName='page-item' // 上記の「…」のクラス名
                        // breakLinkClassName='page-link' // 「…」の中のリンクにつけるクラス
                        /> : null}
                    </div>
                </div>
            </div >
        </>
    );
}


export default MainComponent;